import {IController} from "angular";
import {Branch} from "../model/Branch";
import {BranchesService} from "../../branches_service/service/branches-service";
import {BranchesServiceName, BrandServiceName, ToastNotificationServiceName} from "../../utils/names/serviceNames";
import {groupBy} from "../../utils/UtilArrayFunctions";
import './BrandRoute.scss';
import {BrandService} from "../../brand_service/service/BrandService";
import {Brand} from "../../brand_service/model/Brand";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {Subject} from "rxjs";


export const UnassignedBrandsTitle = 'Unassigned';

export class BranchRouteController implements IController {

    public static instance = ['$mdDialog', BrandServiceName, BranchesServiceName, ToastNotificationServiceName, BranchRouteController];
    public static loaderSubject: Subject<Promise<any>> = new Subject();

    private brands: Brand[];
    private brandBranches: {
        brand: string;
        branches: Branch[];
    }[];

    constructor(private $mdDialog: angular.material.IDialogService,
                private brandService: BrandService,
                private branchesService: BranchesService,
                private toastNotificationService: ToastNotificationService) {
        this.getAllBranches();
        BranchRouteController.loaderSubject.subscribe((promise) => {

        })
    }


    private getAllBranches = () => {
        const brandTask = this.brandService.getBrands();
        const branchesTask = this.branchesService.getAllBranches();
        brandTask
            .then(brands => {
                this.brands = brands.data;
                branchesTask.then(resp => {
                        if (resp.status === 200) {
                            this.brandBranches = BranchRouteController.assignBranchesToBrands(resp.data, brands.data);
                        }
                    }, err => {
                        this.toastNotificationService.generateErrorMessage("Failed to fetch application branches!")
                    }
                );
            });
    };

    private static assignBranchesToBrands(branches: Branch[], brands: Brand[]) {
        let brandBranches = groupBy(branches, 'brandName');
        let unusingnedBranchesKey = undefined;
        let unnasignedBranches = brandBranches[unusingnedBranchesKey];
        brandBranches[UnassignedBrandsTitle] = unnasignedBranches ? unnasignedBranches : [];
        delete brandBranches[unusingnedBranchesKey];
        for (let b of brands) {
            let brandName = b.name;
            if (brandBranches[brandName] == undefined || brandBranches[brandName].length == 0) {
                brandBranches[brandName] = [];
            }
        }

        return this.mapBrandBranches(brandBranches);
    }

    private static mapBrandBranches(brandBranches: { [p: string]: Branch[] }) {
        return Object.entries(brandBranches)
            .map(entry => {
                let brandName = entry[0];
                let branches = entry[1];

                return {
                    brand: brandName,
                    branches: branches
                };
            }).sort((brandBranchesA, brandBranchesB) => {
                if (brandBranchesA.brand === UnassignedBrandsTitle) {
                    return 1;
                } else if (brandBranchesB.brand === UnassignedBrandsTitle) {
                    return -1;
                } else {
                    return brandBranchesA.brand.localeCompare(brandBranchesB.brand);
                }
            });
    }
}